<section class="t-pad-bottom">
  <clinic-filters
    id="clinicSearch"
    class="l-block t-row--med"
    (onSearch)="getClinicsBySearch($event)"
  ></clinic-filters>

  <loader *ngIf="clinicsLoading"></loader>

  <div
    *ngIf="displayClinics && !displayClinics.length"
    role="alert"
    class="c-alert t-alert-info"
  >
    {{ "translate.alert.noResults" | translate }}
  </div>

  <clinic-list
    [clinics]="displayClinics"
    (onEditClinic)="selectedClinic = $event; this.editClinicPanelDisplay = true"
    [totalRecords]="clinicsSearchMetaData.totalRecords"
    [numberOfRows]="numberOfRows"
    (requestUpdate)="loadDataOnPagination($event)"
  ></clinic-list>
</section>

<modal-popup
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="editClinicPanelDisplay = false"
  [isOpen]="editClinicPanelDisplay"
>
  <edit-clinic
    *ngIf="editClinicPanelDisplay"
    [clinic]="selectedClinic"
    (onCancel)="editClinicPanelDisplay = false"
  ></edit-clinic>
</modal-popup>
